import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { remove } from 'lodash';
import { SnackbarTypeEnum } from 'src/app/data/models/enum/snackbar-type.enum';
import { blockedAttachmentsMessage } from 'src/app/data/utils/attachment-security.utils';
import { FileUtils } from 'src/app/data/utils/file.utils';
import { CustomSnackbarService } from '../custom-snackbar/custom-snackbar-service';

@Component({
  selector: 'app-attachment-manager',
  templateUrl: './attachment-manager.component.html',
  styleUrls: ['./attachment-manager.component.scss'],
})
export class AttachmentManagerComponent implements OnInit {
  pdfIcon: string | undefined = '../../../../assets/icons/pdf-img.png';
  imageIcon: string | undefined = '../../../../assets/icons/image-img.png';

  statusMapping: { [k: string]: string } = {
    '=0': 'Nenhum arquivo selecionado',
    '=1': '1 Arquivo selecionado',
    other: '# Arquivos selecionados',
  };

  addItemsText: { [k: string]: string } = {
    '=0': 'Adicionar itens',
    other: 'Adicionar mais itens',
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: File[],
    @Inject(FileUtils) private fileUtils: FileUtils,
    @Inject(CustomSnackbarService)
    private readonly snackbarService: CustomSnackbarService
  ) {}

  ngOnInit(): void {
    this.data = this.filterAllowedFiles(this.data);
  }

  remove(file: File) {
    remove(this.data, (data) => data === file);
  }

  clear() {
    this.data = [];
  }

  add(event: any) {
    const selectedFiles: File[] = Array.from(event.target.files ?? []);
    this.data.push(...this.filterAllowedFiles(selectedFiles));
    event.target.value = '';
  }

  /** Remove arquivos com extensão perigosa ou fora dos tipos aceitos. */
  private filterAllowedFiles(files: File[]): File[] {
    const { allowed, blocked } = this.fileUtils.splitAllowedAttachments(files);

    if (blocked.length > 0) {
      this.snackbarService.open(
        blockedAttachmentsMessage(blocked),
        SnackbarTypeEnum.WARNING,
        'center',
        'top'
      );
    }

    return allowed;
  }

  isImage(file: File): boolean {
    return this.fileUtils.isImage(file.name);
  }
}
